import { render } from "./ReferundumComponent.vue?vue&type=template&id=6b9d9dea&scoped=true&ts=true"
import script from "./ReferundumComponent.vue?vue&type=script&lang=ts"
export * from "./ReferundumComponent.vue?vue&type=script&lang=ts"

import "./ReferundumComponent.vue?vue&type=style&index=0&id=6b9d9dea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b9d9dea"]])

export default __exports__